import React, { Component } from "react";
import { Link, Route, Redirect } from "react-router-dom";
import intl from "react-intl-universal";
import ScrollableAnchor from "react-scrollable-anchor";
import { goToAnchor } from 'react-scrollable-anchor';
import OpenLicenseManager from "../../src/img/HowTos/OpenLicenseManager.gif";
import OpenLicenseManagerTEPlus from "../../src/img/HowTos/OpenLicenseManagerTEPlus.gif";
import OpenLicenseManagerTEProPlus from "../../src/img/HowTos/OpenLicenseManagerTEProPlus.gif";
import LicenseTB from "../../src/img/HowTos/LicenseTB.gif"
import LicensePM from "../../src/img/HowTos/LicensePM.gif";
import CheckoutLicenseManagerTE from "../../src/img/HowTos/CheckoutLicenseManagerTE.gif";
import CheckinLicenseManagerTE from "../../src/img/HowTos/CheckinLicenseManagerTE.gif";
import CheckoutLicenseManagerTEPlus from "../../src/img/HowTos/CheckoutLicenseManagerTEPlus.gif";
import CheckinLicenseManagerTEPlus from "../../src/img/HowTos/CheckinLicenseManagerTEPlus.gif";
import CheckoutLicenseManagerTEProPlus from "../../src/img/HowTos/CheckoutLicenseManagerTEProPlus.gif";
import CheckinLicenseManagerTEProPlus from "../../src/img/HowTos/CheckinLicenseManagerTEProPlus.gif";
import CheckoutLicenseManagerTB from "../../src/img/HowTos/CheckoutLicenseManagerTB.gif";
import CheckinLicenseManagerTB from "../../src/img/HowTos/CheckinLicenseManagerTB.gif";
import CheckoutLicenseManagerPM from "../../src/img/HowTos/CheckoutLicenseManagerPM.gif";
import CheckinLicenseManagerPM from "../../src/img/HowTos/CheckinLicenseManagerPM.gif";
import CheckoutLicenseManagerSG from "../../src/img/HowTos/CheckoutLicenseManagerSG.gif";
import CheckinLicenseManagerSG from "../../src/img/HowTos/CheckinLicenseManagerSG.gif";
import TES_Menu from "../img/HowTos/TES_Menu.png";
import * as SLCommon from "../slCommon";

class GettingStartedProducts extends Component {
  constructor(props) {
    super(props);
    const hashString = window.location.hash;

    var queryParameters = "";
    if (window.location.search.match(/[?&]displayLogin[=]1/gi) !== null) {
      queryParameters = window.location.search
        .replace(/[?&]displaylogin=1[&]?/i, "")
        .replace(/[&]*$/, "")
        .replace(/^[?]/, "");
      if (queryParameters !== "") queryParameters = "?" + queryParameters;

      if (window.location.search.match(/[?&]accessKey[=]([^&]+)/i) === null) {    // if diplayLogin is true and there is no token string in the url
        return (window.location =
          "/store/signIn?redirect=/gettingStartedProducts" +
          queryParameters +
          hashString);
      }
    }

    this.state = {
      packageDetails: [],
      siteName: "",
      packageId: "",
      SGSpremiumData: "premium",
      productAccessToken: "[TOKEN]",
      sgBaseUrl: "https://cloud.skylineglobe.com",
      origHashToScroll: window.location.hash.replace(/^[#](\w+)/i, '$1'),
      copyText: 'Copy',
      copiedText: 'Copied',
      downloadPaths: {},
      selectedTerraExplorerPro: "",
      selectedTerraExplorerPlus: "",
      selectedTerraExplorerProPlus: "",
      selectedPhotoMesh: "",
      selectedPMGigaPixel: "",
      selectedSkylineGlobeServer: "",
      selectedTerraBuilder: "",
      terraExplorerProProducts: [],
      terraExplorerPlusProducts: [],
      terraExplorerProPlusProducts: [],
      photoMeshProducts: [],
      pmGigaPixelProducts: [],
      skylineGlobeServerProducts: [],
      terraBuilderProducts: [],
      isPMGigapixel: false,
      isTrustedCustomer: false,
      protectionType: "floating",
      licenseType: "annual",
      protectionTypeCodes: {},
      isTEProDownloading: false,
      isTEPlusDownloading: false,
      isTEProPlusDownloading: false,
      isPMDownloading: false,
      isSGSDownloading: false,
      isTBDownloading: false,
      expirationDate: "",
      isExpired: true,
      tokenString: "",
      selectedSkylineGlobeServerVersion: "",
      selectedSkylineGlobeServerIsLinux: false
    };
  }

  componentDidMount() {

    if (window.location.search.match(/[?&]premiumData=([^&]+)/i) !== null) {
      this.setState({
        SGSpremiumData: window.location.search.match(
          /[?&]premiumData=([^&]+)/i
        )[1],
      });
    }

    var packageIdParam = window.location.search.match(
      /[?&]packageid[=]([^&]+)/i
    );

    var tokenString = window.location.search.match(
      /[?&]accessKey[=]([^&]+)/i
    );

    if (packageIdParam !== null) {
      this.setState({ packageId: packageIdParam[1] });
    }

    this.getUserStatusData(packageIdParam !== null ? packageIdParam[1] : "", tokenString !== null ? tokenString[1] : "");

    this.setState({ tokenString: tokenString !== null ? tokenString[1] : "" });
  }

  getAllProducts(tokenString) {
    fetch(process.env.REACT_APP_API_URL + "GetAllFlavoursKits", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        tokenString: tokenString
      })
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          result.data.forEach((element => {
            switch (element.BaseProduct) {
              case "TerraExplorerPro":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedTerraExplorerPro: element.ProductName });
                    this.setState(prevState => ({ terraExplorerProProducts: [element, ...prevState.terraExplorerProProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedTerraExplorerPro: element.ProductName });
                    this.setState(prevState => ({ terraExplorerProProducts: [element, ...prevState.terraExplorerProProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      terraExplorerProProducts: [...prevState.terraExplorerProProducts, element]
                    }));
                  }
                }
                break;
              case "TerraExplorerPlus":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedTerraExplorerPlus: element.ProductName });
                    this.setState(prevState => ({ terraExplorerPlusProducts: [element, ...prevState.terraExplorerPlusProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedTerraExplorerPlus: element.ProductName });
                    this.setState(prevState => ({ terraExplorerPlusProducts: [element, ...prevState.terraExplorerPlusProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({terraExplorerPlusProducts: [...prevState.terraExplorerPlusProducts, element]}));
                  }
                }
                break;
              case "TerraExplorerProPlus":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedTerraExplorerProPlus: element.ProductName });
                    this.setState(prevState => ({ terraExplorerProPlusProducts: [element, ...prevState.terraExplorerProPlusProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedTerraExplorerProPlus: element.ProductName });
                    this.setState(prevState => ({ terraExplorerProPlusProducts: [element, ...prevState.terraExplorerProPlusProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      terraExplorerProPlusProducts: [...prevState.terraExplorerProPlusProducts, element]
                    }));
                  }
                }
                break;
              case "PhotoMesh":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedPhotoMesh: element.ProductName });
                    this.setState(prevState => ({ photoMeshProducts: [element, ...prevState.photoMeshProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedPhotoMesh: element.ProductName });
                    this.setState(prevState => ({ photoMeshProducts: [element, ...prevState.photoMeshProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      photoMeshProducts: [...prevState.photoMeshProducts, element]
                    }));
                  }
                }
                break;
              case "PMGigaPixel":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedPMGigaPixel: element.ProductName });
                    this.setState(prevState => ({ pmGigaPixelProducts: [element, ...prevState.pmGigaPixelProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedPMGigaPixel: element.ProductName });
                    this.setState(prevState => ({ pmGigaPixelProducts: [element, ...prevState.pmGigaPixelProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      pmGigaPixelProducts: [...prevState.pmGigaPixelProducts, element]
                    }));
                  }
                }
                break;
              case "SkylineGlobeServer":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ 
                      selectedSkylineGlobeServer: element.ProductName,
                      selectedSkylineGlobeServerVersion: element.ProductVersion || "",
                      selectedSkylineGlobeServerIsLinux: element.IsLinux || false
                    });
                    this.setState(prevState => ({ skylineGlobeServerProducts: [element, ...prevState.skylineGlobeServerProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ 
                      selectedSkylineGlobeServer: element.ProductName,
                      selectedSkylineGlobeServerVersion: element.ProductVersion || "",
                      selectedSkylineGlobeServerIsLinux: element.IsLinux || false
                    });
                    this.setState(prevState => ({ skylineGlobeServerProducts: [element, ...prevState.skylineGlobeServerProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      skylineGlobeServerProducts: [...prevState.skylineGlobeServerProducts, element]
                    }));
                  }
                }
                break;
              case "TerraBuilder":
                if (!element.IsRestricted || this.userHasProductRestricted(element.BaseProduct, element.Id)) {
                  if(this.userHasProductRestricted(element.BaseProduct, element.Id)){
                    this.setState({ selectedTerraBuilder: element.ProductName });
                    this.setState(prevState => ({ terraBuilderProducts: [element, ...prevState.terraBuilderProducts] }));
                  }
                  else if (element.IsDefault) {
                    this.setState({ selectedTerraBuilder: element.ProductName });
                    this.setState(prevState => ({ terraBuilderProducts: [element, ...prevState.terraBuilderProducts] }));
                  }
                  else {
                    this.setState((prevState) => ({
                      terraBuilderProducts: [...prevState.terraBuilderProducts, element]
                    }));
                  }
                }
                break;
              default:
                break;
            }
          }))

          // Ensure restricted versions are always first in each product array and selected
          this.setState(prevState => {
            const sortProductsByRestricted = (products, baseProduct) => {
              return products.sort((a, b) => {
                const aIsRestricted = this.userHasProductRestricted(baseProduct, a.Id);
                const bIsRestricted = this.userHasProductRestricted(baseProduct, b.Id);
                if (aIsRestricted && !bIsRestricted) return -1;
                if (!aIsRestricted && bIsRestricted) return 1;
                if (a.IsDefault && !b.IsDefault) return -1;
                if (!a.IsDefault && b.IsDefault) return 1;
                // Same tier: order by version descending (highest first)
                return this.compareVersionsDesc(a.ProductVersion, b.ProductVersion);
              });
            };

            const sortedTEPro = sortProductsByRestricted([...prevState.terraExplorerProProducts], "TerraExplorerPro");
            const sortedTEPlus = sortProductsByRestricted([...prevState.terraExplorerPlusProducts], "TerraExplorerPlus");
            const sortedTEProPlus = sortProductsByRestricted([...prevState.terraExplorerProPlusProducts], "TerraExplorerProPlus");
            const sortedPM = sortProductsByRestricted([...prevState.photoMeshProducts], "PhotoMesh");
            const sortedPMGP = sortProductsByRestricted([...prevState.pmGigaPixelProducts], "PMGigaPixel");
            const sortedSGS = sortProductsByRestricted([...prevState.skylineGlobeServerProducts], "SkylineGlobeServer");
            const sortedTB = sortProductsByRestricted([...prevState.terraBuilderProducts], "TerraBuilder");

            const updates = {
              terraExplorerProProducts: sortedTEPro,
              terraExplorerPlusProducts: sortedTEPlus,
              terraExplorerProPlusProducts: sortedTEProPlus,
              photoMeshProducts: sortedPM,
              pmGigaPixelProducts: sortedPMGP,
              skylineGlobeServerProducts: sortedSGS,
              terraBuilderProducts: sortedTB
            };

            // Set selected values to restricted versions if they exist, otherwise keep existing or use first item
            if (sortedTEPro.length > 0) {
              const restricted = sortedTEPro.find(p => this.userHasProductRestricted("TerraExplorerPro", p.Id));
              if (restricted) updates.selectedTerraExplorerPro = restricted.ProductName;
            }
            if (sortedTEPlus.length > 0) {
              const restricted = sortedTEPlus.find(p => this.userHasProductRestricted("TerraExplorerPlus", p.Id));
              if (restricted) updates.selectedTerraExplorerPlus = restricted.ProductName;
            }
            if (sortedTEProPlus.length > 0) {
              const restricted = sortedTEProPlus.find(p => this.userHasProductRestricted("TerraExplorerProPlus", p.Id));
              if (restricted) updates.selectedTerraExplorerProPlus = restricted.ProductName;
            }
            if (sortedPM.length > 0) {
              const restricted = sortedPM.find(p => this.userHasProductRestricted("PhotoMesh", p.Id));
              if (restricted) updates.selectedPhotoMesh = restricted.ProductName;
            }
            if (sortedPMGP.length > 0) {
              const restricted = sortedPMGP.find(p => this.userHasProductRestricted("PMGigaPixel", p.Id));
              if (restricted) updates.selectedPMGigaPixel = restricted.ProductName;
            }
            if (sortedSGS.length > 0) {
              const restricted = sortedSGS.find(p => this.userHasProductRestricted("SkylineGlobeServer", p.Id));
              if (restricted) {
                updates.selectedSkylineGlobeServer = restricted.ProductName;
                updates.selectedSkylineGlobeServerVersion = restricted.ProductVersion || "";
                updates.selectedSkylineGlobeServerIsLinux = restricted.IsLinux || false;
              }
            }
            if (sortedTB.length > 0) {
              const restricted = sortedTB.find(p => this.userHasProductRestricted("TerraBuilder", p.Id));
              if (restricted) updates.selectedTerraBuilder = restricted.ProductName;
            }

            return updates;
          });

          if (this.state.selectedTerraExplorerPro === "" && this.state.terraExplorerProProducts.length > 0) {
            console.log(this.state.terraExplorerProProducts[0].ProductName);
            this.setState({ selectedTerraExplorerPro: this.state.terraExplorerProProducts[0].ProductName });
          }
          if (this.state.selectedTerraExplorerPlus === "" && this.state.terraExplorerPlusProducts.length > 0) {
            this.setState({ selectedTerraExplorerPlus: this.state.terraExplorerPlusProducts[0].ProductName });
          }
          if (this.state.selectedTerraExplorerProPlus === "" && this.state.terraExplorerProPlusProducts.length > 0) {
            this.setState({ selectedTerraExplorerProPlus: this.state.terraExplorerProPlusProducts[0].ProductName });
          }
          if (this.state.selectedPhotoMesh === "" && this.state.photoMeshProducts.length > 0) {
            this.setState({ selectedPhotoMesh: this.state.photoMeshProducts[0].ProductName });
          }
          if (this.state.selectedPMGigaPixel === "" && this.state.pmGigaPixelProducts.length > 0) {
            this.setState({ selectedPMGigaPixel: this.state.pmGigaPixelProducts[0].ProductName });
          }
          if (this.state.selectedSkylineGlobeServer === "" && this.state.skylineGlobeServerProducts.length > 0) {
            this.setState({ 
              selectedSkylineGlobeServer: this.state.skylineGlobeServerProducts[0].ProductName,
              selectedSkylineGlobeServerVersion: this.state.skylineGlobeServerProducts[0].ProductVersion || "",
              selectedSkylineGlobeServerIsLinux: this.state.skylineGlobeServerProducts[0].IsLinux || false
            });
          }
          if (this.state.selectedTerraBuilder === "" && this.state.terraBuilderProducts.length > 0) {
            this.setState({ selectedTerraBuilder: this.state.terraBuilderProducts[0].ProductName });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  userHasProductRestricted(baseProduct, baseProductId) {
    return this.state.packageDetails.some(
      (userProduct) => (userProduct.products.BaseProduct === baseProduct) && (userProduct.products.selectedRestrictVersionId != null) && (baseProductId == userProduct.products.selectedRestrictVersionId) 
    );
  }

  getUserStatusData(packageId, tokenString) {
    fetch(process.env.REACT_APP_API_URL + "GetUserDataByPackage", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        packageId: packageId,
        tokenString: tokenString
      }),
    })
      .then((res) => res.json())
      .then((result) => {        
        if (result.Result.toString().toLowerCase() === "success") {
          if (result.PackageDetails !== undefined) {
            this.setState({ packageDetails: result.PackageDetails }, () => {
              this.getAllProducts(tokenString);
            });
          }
          
          if (result.Site && result.Site.SiteName)
            this.setState({
              siteName: result.Site.SiteName
            });

          if (result.PackageAccessToken) {
            this.setState({
              productAccessToken: result.PackageAccessToken
            });
          }

          if (result.TrustedCustomer) {
            this.setState({ isTrustedCustomer: result.TrustedCustomer });
          }

          if (result.ProtectionType) {
            this.setState({ protectionType: result.ProtectionType });
          }

          if (result.ProtectionTypeCodes) {
            this.setState({ protectionTypeCodes: result.ProtectionTypeCodes });
          }

          if (result.LicenseType) {
            this.setState({ licenseType: result.LicenseType });
          }

          if (result.InstallationPaths !== undefined) {
            this.setState({ downloadPaths: result.InstallationPaths });
          }

          if (result.isPMGigapixel !== undefined) {
            this.setState({ isPMGigapixel: true });
          }

          if (result.SGBaseUrl) {
            this.setState({
              sgBaseUrl: result.SGBaseUrl
            });
          }

          if (result.ExpirationDate !== undefined) {
            var today = new Date();
            var expirationDateTemp = new Date(result.ExpirationDate);
            var createdAtGrace = new Date(result.CreatedAt);
            createdAtGrace.setDate(createdAtGrace.getDate() + 30);

            if (expirationDateTemp >= today || createdAtGrace >= today) {
              this.setState({ isExpired: false });
            }
            else {
              this.setState({ isExpired: true });
            }
            this.setState({ expirationDate: result.ExpirationDate });
          }

          if (result.CheckoutLicAllowed != undefined) {
            this.setState({
              checkoutLicAllowed: result.CheckoutLicAllowed,
              checkoutLicDays: result.CheckoutLicDays
            });
          }

          // in case of 'checkoutLicAllowed=true', a re-scrolling is needed
          if (result.CheckoutLicAllowed == true) {
            setTimeout(() => {
              goToAnchor(this.state.origHashToScroll, false);
            }, 1000);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  downloadSelectedKit = (baseProduct, loadingButtonName) => {
    var installationKitPath = "";
    var productVersion = "";
    switch (baseProduct) {
      case "TerraExplorerPro":
        if (this.state.terraExplorerProProducts.length > 0) {
          installationKitPath = this.state.terraExplorerProProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerPro).InstallationKitURL;
          productVersion = this.state.terraExplorerProProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerPro).ProductVersion;
        }
        break;
      case "TerraExplorerPlus":
        if (this.state.terraExplorerPlusProducts.length > 0) {
          installationKitPath = this.state.terraExplorerPlusProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerPlus).InstallationKitURL;
          productVersion = this.state.terraExplorerPlusProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerPlus).ProductVersion;
        }
        break;
      case "TerraExplorerProPlus":
        if (this.state.terraExplorerProPlusProducts.length > 0) {
          installationKitPath = this.state.terraExplorerProPlusProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerProPlus).InstallationKitURL;
          productVersion = this.state.terraExplorerProPlusProducts.find(obj => obj.ProductName == this.state.selectedTerraExplorerProPlus).ProductVersion;
        }
        break;
      case "PhotoMesh":
        if (this.state.photoMeshProducts.length > 0) {
          installationKitPath = this.state.photoMeshProducts.find(obj => obj.ProductName == this.state.selectedPhotoMesh).InstallationKitURL;
          productVersion = this.state.photoMeshProducts.find(obj => obj.ProductName == this.state.selectedPhotoMesh).ProductVersion;
        }
        break;
      case "PMGigaPixel":
        if (this.state.pmGigaPixelProducts.length > 0) {
          installationKitPath = this.state.pmGigaPixelProducts.find(obj => obj.ProductName == this.state.selectedPMGigaPixel).InstallationKitURL;
          productVersion = this.state.pmGigaPixelProducts.find(obj => obj.ProductName == this.state.selectedPMGigaPixel).ProductVersion;
        }
        break;
      case "SkylineGlobeServer":
        if (this.state.skylineGlobeServerProducts.length > 0) {
          installationKitPath = this.state.skylineGlobeServerProducts.find(obj => obj.ProductName == this.state.selectedSkylineGlobeServer).InstallationKitURL;
          productVersion = this.state.skylineGlobeServerProducts.find(obj => obj.ProductName == this.state.selectedSkylineGlobeServer).ProductVersion;
        }
        break;
      case "TerraBuilder":
        if (this.state.terraBuilderProducts.length > 0) {
          installationKitPath = this.state.terraBuilderProducts.find(obj => obj.ProductName == this.state.selectedTerraBuilder).InstallationKitURL;
          productVersion = this.state.terraBuilderProducts.find(obj => obj.ProductName == this.state.selectedTerraBuilder).ProductVersion;
        }
        break;
    }

    if (this.state.protectionType.toLowerCase() !== "floating") {
      this.setState({ [loadingButtonName]: true });

      // let downloadLink = document.createElement('a');
      // downloadLink.href = process.env.REACT_APP_API_URL + `GetInstallationKitPathForProtectionType?installationKitPath=${installationKitPath}&productName=${baseProduct}&packageId=${this.state.packageId}&productVersion=${productVersion}`;
      // downloadLink.download = downloadLink.href.split('/').pop();
      // document.body.appendChild(downloadLink);

      // // Remove the download link after a short delay to ensure the browser starts the download
      // setTimeout(() => {
      //   document.body.removeChild(downloadLink); 
      //   // Hide loader spinner after a delay (adjust the delay duration as needed)
      //   setTimeout(() => {
      //     this.setState({ [loadingButtonName]: false });
      //   }, 500); // Example: Hide spinner after 500 milliseconds
      // }, 100); // Example: Remove link after 100 milliseconds

      // // Trigger the click event to start the download
      // downloadLink.click();
      this.handleDowmloadZipFile(installationKitPath, baseProduct, loadingButtonName, productVersion);
    }
    else {
      if (installationKitPath !== "") {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = installationKitPath;
        a.click();
        window.URL.revokeObjectURL(a);
      }
      //console.log(this.state.terraBuilderProducts.find(obj => obj.ProductName == this.state.selectedTerraBuilder));
    }
  }

  handleDowmloadZipFile = (installationKitPath, baseProduct, loadingButtonName, productVersion) => {
    var filename = '';
    this.setState({ [loadingButtonName]: true });
    fetch(process.env.REACT_APP_API_URL + `GetInstallationKitPathForProtectionType?installationKitPath=${installationKitPath}&productName=${baseProduct}&packageId=${this.state.packageId}&productVersion=${productVersion}&tokenString=${this.state.tokenString}`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then((res) => {

        let downloadLink = document.createElement('a');
        downloadLink.href = process.env.REACT_APP_API_URL + `DownloadInstallationKit?guid=${res.data.guid}&filename=${res.data.filename}`;
        downloadLink.download = downloadLink.href.split('/').pop();
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        this.setState({ [loadingButtonName]: false });

      })
      .catch((error) => {
        this.setState({ [loadingButtonName]: false });
        console.error(error);
        this.props.handleServerError(true);
        return true;
      });
  }

  // Compare two version strings for sort: returns negative if a > b, positive if a < b, 0 if equal.
  // Used to order highest version first (descending).
  compareVersionsDesc = (versionA, versionB) => {
    const parse = (v) => (v || "").toString().split('.').map(part => parseInt(part, 10) || 0);
    const a = parse(versionA);
    const b = parse(versionB);
    const len = Math.max(a.length, b.length);
    for (let i = 0; i < len; i++) {
      const na = a[i] || 0;
      const nb = b[i] || 0;
      if (na !== nb) return nb - na; // descending: higher version first
    }
    return 0;
  };

  // Helper function to compare version strings (e.g., "8.5", "8.5.1", "8.6", "9")
  // Returns true if version >= 8.5
  isVersion8_5OrHigher = (versionString) => {
    if (!versionString) return false;
    
    const versionParts = versionString.split('.').map(part => parseInt(part) || 0);
    const major = versionParts[0] || 0;
    const minor = versionParts[1] || 0;
    
    // Check if version >= 8.5
    if (major > 8) return true;
    if (major === 8 && minor >= 5) return true;
    return false;
  }

  // toggleDrawer = (open, productName) => {
  //   this.setState({ openDrawer: open });
  //   this.setState({ errorProtectionTypeMessage: "" });
  //   this.setState({ activeProductName: productName });

  //   if (open) {
  //     fetch(process.env.REACT_APP_API_URL + "GetProtectionTypeByPackageAndByProductName", {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         packageId: this.state.packageId,
  //         productName: productName
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((result) => {
  //         if (result.success) {
  //           if (result.data.protectionTypeCodes.length > 0) {
  //             // Update protection type to state
  //             this.setState(prevState => ({
  //               protectionTypeCodes: {
  //                 ...prevState.protectionTypeCodes,
  //                 [productName]: result.data.protectionTypeCodes
  //               }
  //             }));

  //             this.setState({ readOnlyTextArea: result.data.protectionTypeCodes.join('\n') });
  //             this.setState({ numOfProtectionTypes: result.data.protectionTypeCodes.length + '/' + result.data.noOfLics });
  //           }
  //         } else {
  //           if (result.data.protectionTypeCodes) {
  //             this.setState({ readOnlyTextArea: result.data.protectionTypeCodes.join('\n') });
  //             this.setState({ numOfProtectionTypes: result.data.protectionTypeCodes.length + '/' + result.data.noOfLics });
  //           }
  //         }
  //         return true;
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         this.setState({ show: false });
  //         this.props.handleServerError(true);
  //         return true;
  //       });
  //   }
  //   else {
  //     this.setState({ showSavedProtectionType: false });
  //     this.setState({ textAreaTexts: "" });
  //     this.setState({ readOnlyTextArea: "" });
  //     this.setState({ numOfProtectionTypes: "-" });
  //   }

  //   // console.log(this.state.packagesData[this.state.packagesData.findIndex(x => x.Id == productId)]);
  //   // console.log(this.state.readOnlyTextArea);

  // }

  // handleChangeMachineCodeInput = (event) => {
  //   this.setState({ textAreaTexts: event.target.value });
  // }

  // handleClearClick = () => {
  //   this.setState({ textAreaTexts: "" });
  //   this.setState({ errorProtectionTypeMessage: "" });
  // }

  render() {
    return (
      <main className="container-fluid col-md-9 faqMain">
        {(this.state.licenseType.toLowerCase() === "perpetual" && !this.state.isExpired) || this.state.licenseType.toLowerCase() === "annual" ?
          <div>
            <div>
              <span style={{ fontSize: "28px" }}>
                Getting Started: Downloading and Activating Skyline Products and
                Services
              </span>
              <br />
              <br />
              <span>
                Listed below are frequently asked questions about SkylineCloud. If
                you have any additional questions, contact us at{" "}
                <a id="supportEmailId" href="mailto:support@skylinesoft.com">support@skylinesoft.com</a>.
              </span>
              <br />
              <br />
              <ul className="faqContentBullets">
                {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined ?
                  <li>
                    <a id="InstallTerraExplorerProTitleId" href="#InstallTerraExplorerProSection">
                      How to download and activate your TerraExplorer Pro
                    </a>
                  </li>
                  : null}
                {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined ?
                  <li>
                    <a id="InstallTerraExplorerPlusTitleId" href="#InstallTerraExplorerPlusSection">
                      How to download and activate your TerraExplorer Plus
                    </a>
                  </li>
                  : null}
                {this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh") !== undefined ||
                  this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel") !== undefined ?
                  <li>
                    <a id="InstallPhotoMeshTitleId" href="#InstallPhotoMeshSection">
                      How to download and activate your PhotoMesh
                    </a>
                  </li>
                  : null}
                {this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer") !== undefined ?
                  <li>
                    <a id="InstallSkylineGlobeServerTitleId" href="#InstallSkylineGlobeServerSection">
                      How to download and activate your SkylineGlobe Server
                    </a>
                  </li>
                  : null}
                {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder") !== undefined ?
                  <li>
                    <a id="InstallTerraBuilderTitleId" href="#InstallTerraBuilderSection">
                      How to download and activate your TerraBuilder
                    </a>
                  </li>
                  : null}
                {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined &&
                  this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined &&
                  this.state.protectionType.toLowerCase() === "floating" ?
                  <li>
                    <a id="InstallTerraExplorerProPlusTitleId" href="#InstallTerraExplorerProPlusSection">
                      How to download and activate your TerraExplorer Pro &amp; Plus (dual installation)
                    </a>
                  </li>
                  : null}
              </ul>
            </div>
            {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined ?
              <ScrollableAnchor id={"InstallTerraExplorerProSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your TerraExplorer Pro
                    </h5>
                    {this.state.protectionType.toLowerCase() !== "floating" &&
                      (this.state.protectionTypeCodes["TerraExplorerPro"] &&
                        (this.state.protectionTypeCodes["TerraExplorerPro"].length > 0
                          && this.state.protectionTypeCodes["TerraExplorerPro"].every(item => item !== '')
                          && this.state.protectionType.toLowerCase() !== "usbkey"
                        )) ?
                      <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                      : null}
                  </div>
                  <p>
                    TerraExplorer Pro is a cutting-edge 3D GIS desktop viewer and
                    creator that provides powerful tools and a high-resolution 3D
                    environment in which to view, query, analyze and present
                    geospatial data. With TerraExplorer Pro you can merge your
                    proprietary 2D and 3D datasets such as BIM models, vector layers
                    and more into the base project, upload your project to the
                    SkylineCloud and share it with your customers.{" "}
                    <a id="TerraExplorerProMoreDetailsId" href="https://support.skylinesoft.com/hc/en-us/categories/360002434720-TerraExplorer-Desktop">
                      More about: TerraExplorer for Desktop
                    </a>
                  </p>
                  {this.state.protectionType.toLowerCase() !== "floating" &&
                    (this.state.protectionTypeCodes["TerraExplorerPro"] &&
                      (this.state.protectionTypeCodes["TerraExplorerPro"].length === 0
                        || this.state.protectionTypeCodes["TerraExplorerPro"].every(item => item === '')
                      )) ?
                    this.state.protectionType.toLowerCase() === "usbkey" ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{intl.getHTML("ProtectionType_Missing_Usb_Key")}</b></span>
                      </div>
                      :
                      this.state.isTrustedCustomer ?
                        <div className="mb-3 missingProtectionType"><span className="mr-3"><b> {this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Missing_MacAddress_Code") : intl.get("ProtectionType_Missing_Machine_Code")}</b></span>
                          {/* <button id="terraExplorerProAddProtectionType" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                          this.toggleDrawer(true, "TerraExplorerPro");
                        }}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</button> */}
                          <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro").Id : 0}`}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</Link>
                        </div>
                      :
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.getHTML("Missing_MacAddress_Not_Trusted") : intl.getHTML("Missing_MachineCode_Not_Trusted")}</b></span></div>
                    :
                    <div>
                      <div>
                        <b>Download and install TerraExplorer Pro</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          <div className="downloadliDiv">
                            <span className="downloadSpan">Download TerraExplorer Pro{" "}</span>
                            <select id="terraExplorerProSelectId" disabled={this.state.isTEProDownloading} className="form-control round defaultCombobox"
                              onChange={(event) => {
                                this.setState({
                                  selectedTerraExplorerPro: event.target.value
                                });
                              }}>
                              {this.state.terraExplorerProProducts.map((row, i) => {
                                return (
                                  <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                );
                              })
                              }
                            </select>
                            <button id="terraExplorerProDownloadButtonId" disabled={this.state.isTEProDownloading} className={this.state.isTEProDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                              this.downloadSelectedKit("TerraExplorerPro", "isTEProDownloading");
                            }}>
                              {this.state.isTEProDownloading ?
                                (<div><span className="downloadSpinner"></span>{this.state.protectionType.toLowerCase() !== "floating" ? " Preparing to Download... " : " Downloading..."}</div>) : (<span>{"Download"}</span>)
                              }
                            </button>
                            {this.state.isTEProDownloading && this.state.protectionType.toLowerCase() !== "floating" ?
                            <span className="downloadSpan ml-2">* This may take a few minutes</span>
                            : null }
                          </div>
                        </li>
                        <li>Uninstall any previous TerraExplorer installations.</li>
                        <li>Extract the zip file you have downloaded.</li>
                        <li>
                          Double-click the <b>setup.exe</b> file and follow the
                          Installation Wizard to install the application.
                        </li>
                      </ul>
                    </div>}
                  {this.state.protectionType.toLowerCase() === "floating" ?
                    (<div>
                      <div>
                        <b>Activate TerraExplorer Pro license</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          Open the <b>License Manager</b> from the Windows <b>Start -&#62;</b>{" "}
                          menu <img className="text-center" src={TES_Menu} />
                        </li>
                        <li>
                          In the <b>License Manager</b>, click <b>File -&#62;</b> {" "}
                          <b>Set Floating License Server...</b>
                        </li>
                        <li>
                          Copy-paste your license URL:{" "}
                          <b className="copyTextForTEProLicURL">
                            {process.env.REACT_APP_HOST +
                              "/sws/" +
                              this.state.productAccessToken}
                          </b>
                          <button id="terraExplorerProCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForTEProLicURL")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>
                          Open TerraExplorer.
                          <br />
                          <br />
                          <img
                            src={OpenLicenseManager}
                            className="text-center howTosImg img-responsive imgStaticHeight"
                          />
                        </li>
                        {
                          this.state.checkoutLicAllowed
                            ?
                            <div>
                              <br />
                              <li>
                                In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                <ul>
                                  <li>
                                    To check out a license:
                                    <ul>
                                      <li>
                                        Validate that TerraExplorer is not running.
                                      </li>
                                      <li>
                                        Click on the "Check Out" button in the License Manager:
                                        <br />
                                        <img
                                          src={CheckoutLicenseManagerTE}
                                          className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <br />
                                  <li>
                                    To check in the license back:
                                    <ul>
                                      <li>
                                        Validate that TerraExplorer is not running.
                                      </li>
                                      <li>
                                        Click on the "Check In" button in the License Manager:
                                        <br />
                                        <img
                                          src={CheckinLicenseManagerTE}
                                          className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </div>
                            :
                            ""
                        }
                      </ul>
                      <br />
                    </div>
                    ) : null}
                  <div>
                    <b>Adding Vertical Datum (GTX) Files:</b>
                  </div>
                  <ul className="">
                    <li>
                      Click{" "}
                      <a href="https://www.skylinesoft.com/verticalDatum.html?tez=1">
                        here
                      </a>{" "}
                      for more information.{" "}
                    </li>
                  </ul>
                </div>
              </ScrollableAnchor>
              : null}
            {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined ?
              <ScrollableAnchor id={"InstallTerraExplorerPlusSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your TerraExplorer Plus
                    </h5>
                    {this.state.protectionType.toLowerCase() !== "floating" &&
                      (this.state.protectionTypeCodes["TerraExplorerPlus"] &&
                        (this.state.protectionTypeCodes["TerraExplorerPlus"].length > 0
                          && this.state.protectionTypeCodes["TerraExplorerPlus"].every(item => item !== '')
                          && this.state.protectionType.toLowerCase() !== "usbkey"
                        )) ?
                      <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                      : null}
                  </div>
                  <p>
                    TerraExplorer Plus is a cutting-edge 3D GIS desktop viewer and
                    creator that provides powerful tools and a high-resolution 3D
                    environment in which to view, query, analyze and present
                    geospatial data. With TerraExplorer Pro you can merge your
                    proprietary 2D and 3D datasets such as BIM models, vector layers
                    and more into the base project, upload your project to the
                    SkylineCloud and share it with your customers.{" "}
                    <a id="TerraExplorerPlusMoreDetailsId" href="https://support.skylinesoft.com/hc/en-us/categories/360002434720-TerraExplorer-Desktop">
                      More about: TerraExplorer for Desktop
                    </a>
                  </p>
                  {this.state.protectionType.toLowerCase() !== "floating" &&
                    (this.state.protectionTypeCodes["TerraExplorerPlus"] &&
                      (this.state.protectionTypeCodes["TerraExplorerPlus"].length === 0
                        || this.state.protectionTypeCodes["TerraExplorerPlus"].every(item => item === '')
                      )) ?
                    this.state.protectionType.toLowerCase() === "usbkey" ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{intl.getHTML("ProtectionType_Missing_Usb_Key")}</b></span>
                      </div>
                      :
                    this.state.isTrustedCustomer ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Missing_MacAddress_Code") : intl.get("ProtectionType_Missing_Machine_Code")} </b></span>
                        {/* <button id="terraExplorerPlusAddProtectionType" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                          this.toggleDrawer(true, "TerraExplorerPlus");
                        }}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</button> */}
                        <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus").Id : 0}`}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</Link>
                      </div>
                      :
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.getHTML("Missing_MacAddress_Not_Trusted") : intl.getHTML("Missing_MachineCode_Not_Trusted")}</b></span></div>
                    :
                    <div>
                      <div>
                        <b>Download and install TerraExplorer Plus:</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          <div className="downloadliDiv">
                            <span className="downloadSpan">Download TerraExplorer Plus{" "}</span>
                            <select id="terraExplorerPlusSelectId" disabled={this.state.isTEPlusDownloading} className="form-control round defaultCombobox"
                              onChange={(event) => {
                                this.setState({
                                  selectedTerraExplorerPlus: event.target.value
                                });
                              }}>
                              {this.state.terraExplorerPlusProducts.map((row, i) => {
                                return (
                                  <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                );
                              })
                              }
                            </select>
                            <button id="terraExplorerPlusDownloadButtonId" disabled={this.state.isTEPlusDownloading} className={this.state.isTEPlusDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                              this.downloadSelectedKit("TerraExplorerPlus", "isTEPlusDownloading");
                            }}>
                              {this.state.isTEPlusDownloading ?
                                (<div><span className="downloadSpinner"></span>{this.state.protectionType.toLowerCase() !== "floating" ? " Preparing to Download... " : " Downloading..."}</div>) : (<span>{"Download"}</span>)
                              }
                            </button>
                            {this.state.isTEPlusDownloading && this.state.protectionType.toLowerCase() !== "floating" ?
                            <span className="downloadSpan ml-2">* This may take a few minutes</span>
                            : null }
                          </div>
                        </li>
                        <li>Uninstall any previous TerraExplorer installations.</li>
                        <li>Extract the zip file you have downloaded.</li>
                        <li>
                          Double-click the <b>setup.exe</b> file, and follow the
                          Installation Wizard to install the application.
                        </li>
                      </ul>
                    </div>}
                  {this.state.protectionType.toLowerCase() === "floating" ?
                    <div>
                      <div>
                        <b>Activate TerraExplorer Plus license</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          Open the <b>License Manager</b> from the Windows <b>Start -&#62;</b>{" "}
                          menu <img className="text-center" src={TES_Menu} />
                        </li>
                        <li>
                          In the <b>License Manager</b>, click on <b>File -&#62;</b> {" "}
                          <b>Set Floating License Server...</b>
                        </li>
                        <li>
                          Enter your license URL:{" "}
                          <b className="copyTextForTEPlusLicURL">
                            {process.env.REACT_APP_HOST +
                              "/sws/" +
                              this.state.productAccessToken}
                          </b>
                          <button id="terraExplorerPlusCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForTEPlusLicURL")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>
                          Open TerraExplorer.
                          <br />
                          <br />
                          <img
                            src={OpenLicenseManagerTEPlus}
                            className="text-center howTosImg img-responsive imgStaticHeight"
                          />
                        </li>
                        {
                          this.state.checkoutLicAllowed
                            ?
                            <div>
                              <br />
                              <li>
                                In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                <ul>
                                  <li>
                                    To check out a license:
                                    <ul>
                                      <li>
                                        Validate that TerraExplorer is not running.
                                      </li>
                                      <li>
                                        Click on the "Check Out" button in the License Manager:
                                        <br />
                                        <img
                                          src={CheckoutLicenseManagerTEPlus}
                                          className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <br />
                                  <li>
                                    To check in the license back:
                                    <ul>
                                      <li>
                                        Validate that TerraExplorer is not running.
                                      </li>
                                      <li>
                                        Click on the "Check In" button in the License Manager:
                                        <br />
                                        <img
                                          src={CheckinLicenseManagerTEPlus}
                                          className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </div>
                            :
                            ""
                        }
                      </ul>
                      <br />
                    </div> : null}
                  <div>
                    <b>Adding Vertical Datum (GTX) Files:</b>
                  </div>
                  <ul className="">
                    <li>
                      Click{" "}
                      <a href="https://www.skylinesoft.com/verticalDatum.html?tez=1">
                        here
                      </a>{" "}
                      for more information.{" "}
                    </li>
                  </ul>
                </div>
              </ScrollableAnchor>
              : null}
            {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPro") !== undefined &&
              this.state.packageDetails.find(x => x.products.BaseProduct === "TerraExplorerPlus") !== undefined
              && this.state.protectionType.toLowerCase() === "floating" ?
              <ScrollableAnchor id={"InstallTerraExplorerProPlusSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your TerraExplorer Pro &amp; Plus (dual installation)
                    </h5>
                  </div>
                  <p>
                    If your SkylineCloud package contains both TerraExplorer Pro and Plus, you can download the dual TerraExplorer installation and easily switch between the two versions.
                  </p>
                    <div>
                      <div>
                        <b>Download and install TerraExplorer Pro &amp; Plus</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          <div className="downloadliDiv">
                            <span className="downloadSpan">Download TerraExplorer Pro & Plus{" "}</span>
                            <select id="terraExplorerProPlusSelectId" disabled={this.state.isTEProPlusDownloading} className="form-control round defaultCombobox"
                              onChange={(event) => {
                                this.setState({
                                  selectedTerraExplorerProPlus: event.target.value
                                });
                              }}>
                              {this.state.terraExplorerProPlusProducts.map((row, i) => {
                                return (
                                  <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                );
                              })
                              }
                            </select>
                            <button id="terraExplorerProPlusDownloadButtonId" disabled={this.state.isTEProPlusDownloading} className={this.state.isTEProPlusDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                              this.downloadSelectedKit("TerraExplorerProPlus", "isTEProPlusDownloading");
                            }}>
                              {this.state.isTEProPlusDownloading ?
                                (<div><span className="downloadSpinner"></span>{" Downloading..."}</div>) : (<span>{"Download"}</span>)
                              }
                            </button>
                          </div>
                        </li>
                        <li>Uninstall any previous TerraExplorer installations.</li>
                        <li>Extract the zip file you have downloaded.</li>
                        <li>
                          Double-click the <b>setup.exe</b> file and follow the
                          Installation Wizard to install the application.
                        </li>
                      </ul>
                        <div>
                          <div>
                            <b>Activate TerraExplorer Pro &amp; Plus licenses</b>
                          </div>
                          <ul className="FAQ_ul">
                            <li>
                              Open the <b>License Manager</b> from the Windows <b>Start -&#62;</b>{" "}
                              menu <img className="text-center" src={TES_Menu} />
                            </li>
                            <li>
                              In the <b>License Manager</b>, click <b>File -&#62;</b> {" "}
                              <b>Set Floating License Server...</b>
                            </li>
                            <li>
                              Copy-paste your license URL:{" "}
                              <b className="copyTextForTEProPlusLicURL">
                                {process.env.REACT_APP_HOST +
                                  "/sws/" +
                                  this.state.productAccessToken}
                              </b>
                              <button id="terraExplorerProPlusCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForTEProPlusLicURL")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                            <li>
                              There are two shortcuts in the Windows Start menu: one for TerraExplorer Pro and second for TerraExplorer Plus.<br />
                              Click the one you want to run.
                            </li>
                            <li>
                              Open TerraExplorer.
                              <br />
                              <br />
                              <img
                                src={OpenLicenseManagerTEProPlus}
                                className="text-center howTosImg img-responsive imgStaticHeight"
                              />
                            </li>
                            {
                              this.state.checkoutLicAllowed
                                ?
                                <div>
                                  <br />
                                  <li>
                                    In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                    <ul>
                                      <li>
                                        To check out a license:
                                        <ul>
                                          <li>
                                            Validate that TerraExplorer is not running.
                                          </li>
                                          <li>
                                            Click on the "Check Out" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckoutLicenseManagerTEProPlus}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                      <br />
                                      <li>
                                        To check in the license back:
                                        <ul>
                                          <li>
                                            Validate that TerraExplorer is not running.
                                          </li>
                                          <li>
                                            Click on the "Check In" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckinLicenseManagerTEProPlus}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </div>
                                :
                                ""
                            }
                          </ul>
                        </div>
                    </div>
                  <div>
                    <b>Adding Vertical Datum (GTX) Files:</b>
                  </div>
                  <ul className="">
                    <li>
                      Click{" "}
                      <a href="https://www.skylinesoft.com/verticalDatum.html?tez=1">
                        here
                      </a>{" "}
                      for more information.{" "}
                    </li>
                  </ul>
                </div>
              </ScrollableAnchor>
              : null}
            {this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh") !== undefined ||
              this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel") !== undefined ?
              <ScrollableAnchor id={"InstallPhotoMeshSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your PhotoMesh
                    </h5>
                    {this.state.protectionType.toLowerCase() !== "floating" &&
                      (this.state.protectionTypeCodes["PhotoMesh"] &&
                        (this.state.protectionTypeCodes["PhotoMesh"].length > 0
                          && this.state.protectionTypeCodes["PhotoMesh"].every(item => item !== '')
                          && this.state.protectionType.toLowerCase() !== "usbkey"
                        )) ?
                      <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                      : this.state.protectionType.toLowerCase() !== "floating" &&
                        (this.state.protectionTypeCodes["PMGigaPixel"] &&
                          (this.state.protectionTypeCodes["PMGigaPixel"].length > 0
                            && this.state.protectionTypeCodes["PMGigaPixel"].every(item => item !== '')
                            && this.state.protectionType.toLowerCase() !== "usbkey"
                          )) ?
                        <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                        : null}
                  </div>
                  <p>
                    PhotoMesh fully automates the generation of high-resolution,
                    textured, 3D mesh models from oblique and nadir photographs and
                    Lidar captured from street view, drones, UAV and airplanes.
                    PhotoMesh’s breakthrough technology is based on the
                    highest-performance photogrammetry, computer vision, and
                    computational geometry algorithms. PhotoMesh results can be
                    generated in standard 3D model (3DML, 3D Tiles, DAE, OBJ, OSGB,
                    I3S/SLPK), raster (Orthophoto, DSM, DTM) and point cloud (LAS)
                    formats. {" "}
                    <a id="PhotoMeshMoreDetailsId" href="https://support.skylinesoft.com/hc/en-us/categories/360002453079-PhotoMesh">Learn more</a>
                  </p>
                  {this.state.protectionType.toLowerCase() !== "floating" &&
                    (this.state.protectionTypeCodes["PhotoMesh"] &&
                      (this.state.protectionTypeCodes["PhotoMesh"].length === 0
                        || this.state.protectionTypeCodes["PhotoMesh"].every(item => item === '')
                      )) ||
                    (this.state.protectionTypeCodes["PMGigaPixel"] &&
                      (this.state.protectionTypeCodes["PMGigaPixel"].length === 0
                        || this.state.protectionTypeCodes["PMGigaPixel"].every(item => item === '')
                      ))
                    ?
                    this.state.protectionType.toLowerCase() === "usbkey" ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{intl.getHTML("ProtectionType_Missing_Usb_Key")}</b></span>
                      </div>
                      :
                      this.state.isTrustedCustomer ?
                        (<div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Missing_MacAddress_Code") : intl.get("ProtectionType_Missing_Machine_Code")}</b></span>
                          <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "PhotoMesh").Id : this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "PMGigaPixel").Id : 0}`}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</Link>
                        </div>) :
                        <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.getHTML("Missing_MacAddress_Not_Trusted") : intl.getHTML("Missing_MachineCode_Not_Trusted")}</b></span></div>
                    :
                    <div>
                      <div>
                        <b>Download and install PhotoMesh</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          <div className="downloadliDiv">
                            <span className="downloadSpan">Download PhotoMesh{" "}</span>
                            <select id="photoMeshSelectId" disabled={this.state.isPMDownloading} className="form-control round defaultCombobox"
                              onChange={(event) => {
                                if (this.state.isPMGigapixel)
                                  this.setState({ selectedPMGigaPixel: event.target.value });
                                else this.setState({ selectedPhotoMesh: event.target.value });
                              }}>
                              {this.state.isPMGigapixel ? this.state.pmGigaPixelProducts.map((row, i) => {
                                return (
                                  <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                );
                              })
                                : this.state.photoMeshProducts.map((row, i) => {
                                  return (
                                    <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                  );
                                })
                              }
                            </select>
                            <button id="photoMeshDownloadButtonId" disabled={this.state.isPMDownloading} className={this.state.isPMDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                              { this.state.isPMGigapixel ? this.downloadSelectedKit("PMGigaPixel", "isPMDownloading") : this.downloadSelectedKit("PhotoMesh", "isPMDownloading") }
                            }}>
                              {this.state.isPMDownloading ?
                                (<div><span className="downloadSpinner"></span>{this.state.protectionType.toLowerCase() !== "floating" ? " Preparing to Download... " : " Downloading..."}</div>) : (<span>{"Download"}</span>)
                              }
                            </button>
                            {this.state.isPMDownloading && this.state.protectionType.toLowerCase() !== "floating" ?
                            <span className="downloadSpan ml-2">* This may take a few minutes</span>
                            : null }
                          </div>
                        </li>
                        <li>Uninstall any previous PhotoMesh installations.</li>
                        <li>Extract the zip file.</li>
                        <li>
                          Double-click the <b>PhotoMeshSetup.msi</b> or <b>PhotoMesh.exe</b> file and follow the
                          Installation Wizard to install.
                        </li>
                      </ul>
                      {this.state.protectionType.toLowerCase() === "floating" ?
                        <div>
                          <div>
                            <b>Activate PhotoMesh license:</b>
                          </div>
                          <ul className="FAQ_ul">
                            <li>
                              Open the License Manager: C:\Program
                              Files\Skyline\PhotoMesh\LicenseManager.exe or from the
                              installed folder.
                            </li>
                            <li>
                              In the <b>License Manager</b>, click on <b>File -&#62;</b> {" "}
                              <b>Set Floating License Server...</b>
                            </li>
                            <li>
                              Enter your license URL:{" "}
                              <b className="copyTextForPMLicURL">
                                {process.env.REACT_APP_HOST +
                                  "/sws/" +
                                  this.state.productAccessToken}
                              </b>
                              <button id="photoMeshCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForPMLicURL")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                            <li>
                              Start PhotoMesh from the windows <b>Start</b> menu or from the
                              desktop shortcut.
                              <br />
                              <br />
                              <img
                                src={LicensePM}
                                className="text-center howTosImg img-responsive imgStaticHeight"
                              />
                            </li>
                            {
                              this.state.checkoutLicAllowed
                                ?
                                <div>
                                  <br />
                                  <li>
                                    In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                    <ul>
                                      <li>
                                        To check out a license:
                                        <ul>
                                          <li>
                                            Validate that PhotoMesh is not running.
                                          </li>
                                          <li>
                                            Click on the "Check Out" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckoutLicenseManagerPM}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                      <br />
                                      <li>
                                        To check in the license back:
                                        <ul>
                                          <li>
                                            Validate that PhotoMesh is not running.
                                          </li>
                                          <li>
                                            Click on the "Check In" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckinLicenseManagerPM}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </div>
                                :
                                ""
                            }
                          </ul>
                        </div> : null}
                    </div>}
                  <div>
                    <br />
                    <b>Get to know the PhotoMesh GUI and build an example project:</b>
                  </div>
                  <ul className="FAQ_ul">
                    <li>
                      On the PhotoMesh Start Page, download one of the ready-to-build example projects, and follow the instructions to get started building.
                      <br />
                      <img src={""} className="text-center howTosImg img-responsive" />
                    </li>
                    <li>
                      Explore Skyline's <a id="photoMeshKnowledgeBaseLinkId" href="https://support.skylinesoft.com/hc/en-us/categories/360002453079-PhotoMesh">knowledge base</a> with information about PhotoMesh:
                    </li>
                    <ul>
                      <li>Get to know PhotoMesh through clear and to-the-point <a id="photoMeshVideoTutorialsId" href="https://support.skylinesoft.com/hc/en-us/articles/360013938579-PhotoMesh-Video-Tutorials">video tutorials</a>.</li>
                      <li>Use our <a id="photoMeshQuickStartTutorialId" href="https://support.skylinesoft.com/hc/en-us/sections/360003834779-Tutorials">quick start tutorials</a> to guide you through the basic PhotoMesh workflow. </li>
                      <li>Learn about PhotoMesh’s <a id="photoMeshLearnMoreProjectTreeId" href="https://support.skylinesoft.com/hc/en-us/articles/360019809839-Project-Tree-and-Item-List">Project Tree and Item List</a>.</li>
                      <li>Read our recommendations for <a id="photoMeshImageryAndDataCollectionId" href="https://support.skylinesoft.com/hc/en-us/articles/360013116380-Recommendations-for-Imagery-Acquisition-and-Data-Collection">imagery acquisition and data collection</a>.</li>
                    </ul>
                  </ul>
                </div>
              </ScrollableAnchor>
              : null}
            {this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer") !== undefined ?
              <ScrollableAnchor id={"InstallSkylineGlobeServerSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your SkylineGlobe Server
                    </h5>
                    {this.state.protectionType.toLowerCase() !== "floating" &&
                      (this.state.protectionTypeCodes["SkylineGlobeServer"] &&
                        (this.state.protectionTypeCodes["SkylineGlobeServer"].length > 0
                          && this.state.protectionTypeCodes["SkylineGlobeServer"].every(item => item !== '')
                          && this.state.protectionType.toLowerCase() !== "usbkey"
                        )) ?
                      <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                      : null}
                  </div>
                  <p>
                    SkylineGlobe Server (SGS) is a private cloud solution that
                    provides a comprehensive set of web services for publishing,
                    storing, managing and streaming 3D spatial data. The server’s
                    built-in complete user access control system allows easy
                    management of users, groups, and administrative roles
                    controlling the server-side storage and client-side read/write
                    permissions.{" "}
                    <a id="SkylineGlobeServerMoreDetailsId" href="https://support.skylinesoft.com/hc/en-us/categories/360002453099-SkylineGlobe-Server">
                      Learn more
                    </a>
                  </p>
                  {this.state.protectionType.toLowerCase() !== "floating" &&
                    (this.state.protectionTypeCodes["SkylineGlobeServer"] &&
                      (this.state.protectionTypeCodes["SkylineGlobeServer"].length === 0
                        || this.state.protectionTypeCodes["SkylineGlobeServer"].every(item => item === '')
                      )) ?
                    this.state.protectionType.toLowerCase() === "usbkey" ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{intl.getHTML("ProtectionType_Missing_Usb_Key")}</b></span>
                      </div>
                      :
                      this.state.isTrustedCustomer ?
                        <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Missing_MacAddress_Code") : intl.get("ProtectionType_Missing_Machine_Code")}</b></span>
                          <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "SkylineGlobeServer").Id : 0}`}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</Link>
                        </div>
                        :
                        <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.getHTML("Missing_MacAddress_Not_Trusted") : intl.getHTML("Missing_MachineCode_Not_Trusted")}</b></span></div>
                    :
                    <div>
                      <div>
                        <b>Download and install SkylineGlobe Server</b>
                      </div>
                        <ul className="FAQ_ul">
                          <li>
                            <div className="downloadliDiv">
                              <span className="downloadSpan">Download SkylineGlobe Server{" "}</span>
                              <select id="skylineGlobeServerSelectId" disabled={this.state.isSGSDownloading} className="form-control round defaultCombobox"
                                onChange={(event) => {
                                  const selectedProduct = this.state.skylineGlobeServerProducts.find(obj => obj.ProductName === event.target.value);
                                  this.setState({
                                    selectedSkylineGlobeServer: event.target.value,
                                    selectedSkylineGlobeServerVersion: selectedProduct ? selectedProduct.ProductVersion : "",
                                    selectedSkylineGlobeServerIsLinux: selectedProduct ? (selectedProduct.IsLinux || false) : false
                                  });
                                }}>
                                {this.state.skylineGlobeServerProducts.map((row, i) => {
                                  return (
                                    <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                  );
                                })
                                }
                              </select>
                              <button id="skylineGlobeServerDownloadButtonId" disabled={this.state.isSGSDownloading} className={this.state.isSGSDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                                this.downloadSelectedKit("SkylineGlobeServer", "isSGSDownloading");
                              }}>
                                {this.state.isSGSDownloading ?
                                  (<div><span className="downloadSpinner"></span>{this.state.protectionType.toLowerCase() !== "floating" ? " Preparing to Download... " : " Downloading..."}</div>) : (<span>{"Download"}</span>)
                                }
                              </button>
                              {this.state.isSGSDownloading && this.state.protectionType.toLowerCase() !== "floating" ?
                              <span className="downloadSpan ml-2">* This may take a few minutes</span>
                              : null }
                            </div>
                          </li>
                          {this.isVersion8_5OrHigher(this.state.selectedSkylineGlobeServerVersion) ? 
                              <>
                                <li>Extract the ZIP contents to a local folder on your target machine.</li>
                                <li>To see detailed instructions on how to install SkylineGlobe Server, <a href="https://support.skylinesoft.com/hc/en-us/articles/23630404639900-Deploy-SkylineGlobe-Server">click here.</a></li>
                              </>
                            : (
                            <>
                              <li>
                                Uninstall any previous SkylineGlobe Server installations.
                              </li>
                              <li>Extract the zip file.</li>
                              <li>
                                Double-click the <b>SkylineGlobeServerSetup.exe</b> file and
                                follow the Installation Wizard to install.
                              </li>
                              </>
                            )}
                            </ul>
                      {this.state.protectionType.toLowerCase() === "floating" ?
                        <div>
                          <div>
                            <b>Activate SkylineGlobe Server license</b>
                          </div>
                          <ul className="FAQ_ul">
                            <li>
                              Open the License Manager:
                              C:\inetpub\wwwroot\SG\LicenseManager.exe
                            </li>
                            <li>
                              In the <b>License Manager</b>, click on <b>File -&#62;</b> {" "}
                              <b>Set Floating License Server...</b>
                            </li>
                            <li>
                              Enter your license URL:{" "}
                              <b className="copyTextForSGSLicURL">
                                {process.env.REACT_APP_HOST +
                                  "/sws/" +
                                  this.state.productAccessToken}
                              </b>
                              <button id="skylineGlobeServerCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForSGSLicURL")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                            Open SkylineGlobe Server from the Windows <b>Start</b> menu or
                              from desktop shortcut.
                            <li>
                              Start SkylineGlobe Server Manager and log in: the default user name and password after installation are <b>admin</b> and <b>admin</b> (lower-case). After logging in, change your password in the Change default administrator password page that is displayed.
                            </li>
                            {
                              this.state.checkoutLicAllowed
                                ?
                                <div>
                                  <li>
                                    In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                    <ul>
                                      <li>
                                        To check out a license:
                                        <ul>
                                          <li>
                                            Click on the "Check Out" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckoutLicenseManagerSG}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                      <br />
                                      <li>
                                        To check in the license back:
                                        <ul>
                                          <li>
                                            Click on the "Check In" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckinLicenseManagerSG}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </div>
                                :
                                ""
                            }
                          </ul>
                        </div> : null}
                    </div>}
                </div>
              </ScrollableAnchor>
              : null}
            {this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder") !== undefined ?
              <ScrollableAnchor id={"InstallTerraBuilderSection"}>
                <div className="FAQ_Pricing productDiv">
                  <div className="headersHowToProduct">
                    <h5 className="headersHowTo">
                      How to download and activate your TerraBuilder
                    </h5>
                    {this.state.protectionType.toLowerCase() !== "floating" &&
                      (this.state.protectionTypeCodes["TerraBuilder"] &&
                        (this.state.protectionTypeCodes["TerraBuilder"].length > 0
                          && this.state.protectionTypeCodes["TerraBuilder"].every(item => item !== '')
                          && this.state.protectionType.toLowerCase() !== "usbkey"
                        )) ?
                      <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder").Id : 0}`}>{this.state.isTrustedCustomer ? "Edit " : "View "} {this.state.protectionType.toLowerCase() === "macaddress" ? "Mac Addresses" : "Machine Codes"}</Link>
                      : null}
                  </div>
                  <p>
                    TerraBuilder is a 3D terrain database creator.
                    TerraBuilder features professional-grade tools for
                    manipulating and merging aerial photos, satellite images,
                    and digital elevation models of different sizes and resolutions.{" "}
                    <a id="terraBuilderMoreDetailsId" href="https://support.skylinesoft.com/hc/en-us/categories/4402989250834-TerraBuilder">
                      More about: TerraBuilder
                    </a>
                  </p>
                  {this.state.protectionType.toLowerCase() !== "floating" &&
                    (this.state.protectionTypeCodes["TerraBuilder"] &&
                      (this.state.protectionTypeCodes["TerraBuilder"].length === 0
                        || this.state.protectionTypeCodes["TerraBuilder"].every(item => item === '')
                      )) ?
                    this.state.protectionType.toLowerCase() === "usbkey" ?
                      <div className="mb-3 missingProtectionType"><span className="mr-3"><b>{intl.getHTML("ProtectionType_Missing_Usb_Key")}</b></span>
                      </div>
                      :
                      this.state.isTrustedCustomer ?
                        (<div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Missing_MacAddress_Code") : intl.get("ProtectionType_Missing_Machine_Code")}</b></span>
                          <Link className="btn btn-outline-primary text-capitalize copyToClipboard" to={`/account/${this.state.packageId}/${this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder") !== undefined ? this.state.packageDetails.find(x => x.products.BaseProduct === "TerraBuilder").Id : 0}`}>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.get("ProtectionType_Add_Mac_Address") : intl.get("ProtectionType_Add_Machine_Code")}</Link>
                        </div>)
                        :
                        (<div className="mb-3 missingProtectionType"><span className="mr-3"><b>{this.state.protectionType.toLowerCase() === "macaddress" ? intl.getHTML("Missing_MacAddress_Not_Trusted") : intl.getHTML("Missing_MachineCode_Not_Trusted")}</b></span></div>)
                    :
                    <div>
                      <div>
                        <b>Download and install TerraBuilder</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          <div className="downloadliDiv">
                            <span className="downloadSpan">Download TerraBuilder{" "}</span>
                            <select id="terraBuilderSelectId" disabled={this.state.isTBDownloading} className="form-control round defaultCombobox"
                              onChange={(event) => {
                                this.setState({
                                  selectedTerraBuilder: event.target.value
                                });
                              }}>
                              {this.state.terraBuilderProducts.map((row, i) => {
                                return (
                                  <option id={row.ProductName} className="" key={i}>{row.ProductName}</option>
                                );
                              })
                              }
                            </select>
                            <button id="terraBuilderDownloadButtonId" disabled={this.state.isTBDownloading} className={this.state.isTBDownloading ? "btn btn-primary text-capitalize ml-2 downloadButton button-downloading" : "btn btn-primary text-capitalize ml-2 downloadButton"} onClick={(event) => {
                              this.downloadSelectedKit("TerraBuilder", "isTBDownloading");
                            }}>
                              {this.state.isTBDownloading ?
                                (<div><span className="downloadSpinner"></span>{this.state.protectionType.toLowerCase() !== "floating" ? " Preparing to Download... " : " Downloading..."}</div>) : (<span>{"Download"}</span>)
                              }
                            </button>
                            {this.state.isTBDownloading && this.state.protectionType.toLowerCase() !== "floating" ?
                            <span className="downloadSpan ml-2">* This may take a few minutes</span>
                            : null }
                          </div>
                        </li>
                        <li>Uninstall any previous TerraBuilder installations.</li>
                        <li>Extract the zip file you have downloaded.</li>
                        <li>
                          Double-click the <b>TerraBuilderSetup.exe</b> file and follow the
                          Installation Wizard to install the application.
                        </li>
                      </ul>
                      {this.state.protectionType.toLowerCase() === "floating" ?
                        <div>
                          <div>
                            <b>Activate TerraBuilder license</b>
                          </div>
                          <ul className="FAQ_ul">
                            <li>
                              Open the <b>License Manager</b> from the Windows <b>Start -&#62;</b>{" "}
                              menu <img className="text-center" src={TES_Menu} />
                            </li>
                            <li>
                              In the <b>License Manager</b>, click <b>File -&#62;</b> {" "}
                              <b>Set Floating License Server...</b>
                            </li>
                            <li>
                              Copy-paste your license URL:{" "}
                              <b className="copyTextForTBLicURL">
                                {process.env.REACT_APP_HOST +
                                  "/sws/" +
                                  this.state.productAccessToken}
                              </b>
                              <button id="terraBuilderCopyTokenId" className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForTBLicURL")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                            <li>
                              Open TerraBuilder.
                              <br />
                              <br />
                              <img
                                src={LicenseTB}
                                className="text-center howTosImg img-responsive imgStaticHeight"
                              />
                            </li>
                            {
                              this.state.checkoutLicAllowed
                                ?
                                <div>
                                  <br />
                                  <li>
                                    In this package, there is an option to use the product in an offline mode (Check out License) up to {this.state.checkoutLicDays} days:
                                    <ul>
                                      <li>
                                        To check out a license:
                                        <ul>
                                          <li>
                                            Validate that TerraBuilder is not running.
                                          </li>
                                          <li>
                                            Click on the "Check Out" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckoutLicenseManagerTB}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                      <br />
                                      <li>
                                        To check in the license back:
                                        <ul>
                                          <li>
                                            Validate that TerraBuilder is not running.
                                          </li>
                                          <li>
                                            Click on the "Check In" button in the License Manager:
                                            <br />
                                            <img
                                              src={CheckinLicenseManagerTB}
                                              className="text-center howTosImg img-responsive imgSmallStaticHeight"
                                            />
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </div>
                                :
                                ""
                            }
                          </ul>
                        </div> : null}
                    </div>}
                </div>
              </ScrollableAnchor>
              : null}
            <br />
            <br />
            <br />
          </div>
          : <div>
            <span style={{ fontSize: "28px" }}>
              {intl.get("Perpetual_License_Expired")}
            </span>
          </div>}
      </main>
    );
  }
}

export default GettingStartedProducts;
